<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >

            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        label="Variável"
                        :options="data.form.variaveis"
                        show-default-option
                        default-option-text="Selecione"
                        text-field="fator"
                        value-field="id"
                        :validations="validations.fatorId"
                        v-model="model.fatorId"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Ordem"
                        v-model="model.ordem"
                        number
                    />
                </rkm-col>

                <rkm-col class="flex-grow-0 text-nowrap">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"
                    >
                    {{ hasIndex  ? 'Alterar' : 'Incluir' }}
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        color="secondary"
                        @click.stop="resetForm"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <List
            v-if="!hasIndex"
            ref="List"
            :data="data"
            :item="item"
            @handleAlter="handleAlter"
        />
    </div>
</template>

<script>

// Mixins.
import { repository, stringCase, object, error, } from '@/mixins'

// Components
import List from './List'

export default {
    components: {
        List,
    },
    computed: {
        validations() {
            return {
                 fatorId: {
                    required: true,
                },
            }
        },
        hasIndex() {

            return this.index !== null
        },
    },
    data: () => ({
        model: {
            id: null,
            fatorId: null,
            fator: '',
            ordem: null,
        },
        index: null,
    }),
    mixins: [ repository, stringCase, object, error ],
    props: {
        data: { type: Object, required: true },
        item: { type: Object, required: true },
    },
    methods: {
       add() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.hasParametrizada()) {

                        this.showValidationNotification(
                            `Registro já parametrizado com a descrição <strong>${this.model.descricao}</strong>.`
                        )

                        return
                    }

                    const variavel = this.clone(this.model)

                    const fator = this.data.form.variaveis.find(u => u.id === this.model.fatorId)

                    variavel.fator = fator.fator

                    if (this.hasIndex) {

                        const objId = this.item.variavel.findIndex((obj => obj.id == this.model.id));

                        this.$set(this.item.variavel, objId, variavel)
                    } else {

                        variavel.id = this.uniqueId('variavel' + new Date().getTime())

                        this.item.variavel.push(variavel)
                    }

                    this.resetForm()
            })
        },
        hasParametrizada() {

            return this.item.variavel.find((variavel) => variavel.id !== this.model.id
                && variavel.fatorId === this.model.fatorId)
        },
        validate() {

            return this.$refs.Form.validate()
        },
        resetForm() {

            this.index = null

            this.model.id = null
            this.model.fatorId = null
            this.model.fator = ''
            this.model.ordem = ''

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleAlter(index, item) {

            this.index = index
            this.model.id = item.id
            this.model.fatorId = item.fatorId
            this.model.fator = item.fator
            this.model.ordem = item.ordem
        }
    },
}
</script>